import './customerPortal.css';

import { ApolloError } from '@apollo/client';
import React from 'react';

import { MutationSendCoiArgs, SendCoiMutation } from '../../generated/graphql';

interface CoiParams {
  policyId: string;
  country: string;
  sendCoi: (sendCoiArgs: { variables: MutationSendCoiArgs }) => void;
  coiData?: SendCoiMutation | null;
  coiError?: ApolloError;
}

const Coi: React.FC<CoiParams> = ({
  country,
  sendCoi,
  coiData,
  policyId,
  coiError
}) => {
  const handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    const formData = new FormData(e.target as HTMLFormElement);
    const name = (formData.get('name') as string) || '';
    const city = (formData.get('city') as string) || '';
    const street = (formData.get('street') as string) || '';
    const province = (formData.get('province') as string) || '';
    const postalCode = (formData.get('postalCode') as string) || '';

    const additionalInsured = {
      name,
      address: { street, city, province, postalCode }
    };
    sendCoi({
      variables: {
        policyFoxdenId: policyId,
        country: country,
        additionalInsured
      }
    });
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      const form = e.currentTarget.closest('form');
      if (form) {
        const submitEvent = new Event('submit', {
          bubbles: true,
          cancelable: true
        });
        form.dispatchEvent(submitEvent);
      }
    }
  };

  const coiBox = (
    <div className="py-5">
      <form onSubmit={handleSubmit}>
        <table>
          <tbody className="text-base lowercase">
            <tr>
              <td>Name:</td>
              <td>
                <input
                  type="text"
                  className="border-2"
                  name="name"
                  aria-label="Name"
                  onKeyDown={handleKeyDown}
                />
              </td>
            </tr>
            <tr>
              <td>Street:</td>
              <td>
                <input
                  type="text"
                  className="border-2"
                  name="street"
                  aria-label="Street"
                  onKeyDown={handleKeyDown}
                />
              </td>
            </tr>
            <tr>
              <td>City:</td>
              <td>
                <input
                  type="text"
                  className="border-2"
                  name="city"
                  aria-label="City"
                  onKeyDown={handleKeyDown}
                />
              </td>
            </tr>
            <tr>
              <td>Province:</td>
              <td>
                <input
                  type="text"
                  className="border-2"
                  name="province"
                  aria-label="Province"
                  onKeyDown={handleKeyDown}
                />
              </td>
            </tr>
            <tr>
              <td>PostalCode:</td>
              <td>
                <input
                  type="text"
                  className="border-2"
                  name="postalCode"
                  aria-label="postalcode"
                  onKeyDown={handleKeyDown}
                />
              </td>
            </tr>
          </tbody>
        </table>
        <button type="submit" value="Submit" className="border-2">
          send coi
        </button>
      </form>
    </div>
  );

  const sendCoiResult = (() => {
    if (coiData) {
      return <div>send COI success</div>;
    } else if (coiError) {
      return <div>send COI fail</div>;
    } else {
      return null;
    }
  })();

  return (
    <div className=" pl-10 place-items-start gap-4 pt-10 ">
      <div className="row-start-1 text-xl uppercase font-bold">COI</div>
      {coiBox}
      {sendCoiResult}
    </div>
  );
};

export default Coi;
